export const View = axios => ({
  preview(profileSlug, processSlug) {
    if (processSlug) {
      return axios.get(`/v1/profiles/${profileSlug}/preview/${processSlug}`)
    }

    return axios.get(`/v1/profiles/${profileSlug}/preview/`)
  },
  personal(slug) {
    return axios.get(`/v1/profiles/${slug}/view/personal`)
  },
  professional(slug) {
    return axios.get(`/v1/profiles/${slug}/view/professional`)
  },
  professionalTab(slug) {
    return axios.get(`/v1/profiles/${slug}/view/professional/tab`)
  },
  personalTab(slug) {
    return axios.get(`/v1/profiles/${slug}/view/personal/tab`)
  },
  statistics(slug) {
    return axios.get(`/v1/profiles/${slug}/view/statistics`)
  },
  collapse(slug) {
    return axios.get(`/v1/profiles/${slug}/view/collapse`)
  },
  head(slug) {
    return axios.get(`/v1/profiles/${slug}/view/head`)
  },
  headEdit(slug) {
    return axios.get(`/v1/profiles/${slug}/view/head-edit`)
  },
  activities(slug) {
    return axios.get(`/v1/profiles/${slug}/activities`)
  },
  processes(slug, filters = {}, page = 1, perPage = 1000) {
    return axios.get(`/v1/profiles/${slug}/processes`, { params: { page, per_page: perPage, ...filters } })
  },
  deAnonymise(profileSlug, processSlug) {
    return axios.get(`/v1/profiles/${profileSlug}/de-anonymize/${processSlug}`)
  }
})
